import React from 'react'

import UserIcon from '../../../assets/icons/user.svg?react'
import ClockIcon from '../../../assets/icons/clock.svg?react'
import VideoIcon from '../../../assets/icons/play.svg?react'
import PlayIcon from '../../../assets/icons/play-circle-no-fill.svg?react'
import DocumentIcon from '../../../assets/icons/document.svg?react'
import CalendarIcon from '../../../assets/icons/calendar.svg?react'
import ZriveIcon from '../../../assets/icons/zrive-iso.svg?react'
import CheckedIcon from '../../../assets/icons/checked.svg?react'
import StarsIcon from '../../../assets/icons/stars.svg?react'

type Props = {
  icon: 'author' | 'clock' | 'video' | 'document' | 'calendar' | 'zrive' | 'play' | 'checked' | 'ai'
  children: React.ReactNode | string
  strokeColor?: string
  lineClamp?: number
}
const MetadataLabel: React.FC<Props> = ({ icon, children, strokeColor, lineClamp = 2 }) => {
  let iconElement
  const iconClass = `w-5 h-5 shrink-0 ${strokeColor ? `stroke-${strokeColor}` : 'stroke-gray'}`
  switch (icon) {
    case 'author': {
      iconElement = <UserIcon className={iconClass} />
      break
    }
    case 'clock': {
      iconElement = <ClockIcon className={iconClass} />
      break
    }
    case 'video': {
      iconElement = <VideoIcon className={iconClass} />
      break
    }
    case 'play': {
      iconElement = <PlayIcon className={iconClass} />
      break
    }
    case 'document': {
      iconElement = <DocumentIcon className={`${iconClass} py-0.5`} />
      break
    }
    case 'calendar': {
      iconElement = <CalendarIcon className={iconClass} />
      break
    }
    case 'zrive': {
      iconElement = <ZriveIcon className={iconClass} />
      break
    }
    case 'checked': {
      iconElement = <CheckedIcon className={iconClass} />
      break
    }
    case 'ai': {
      iconElement = <StarsIcon className={iconClass} />
      break
    }
    default: {
      iconElement = null
      break
    }
  }
  return (
    <div className='flex items-center gap-x-1.5'>{iconElement} <span className={`line-clamp-${lineClamp}`}>{children}</span></div>
  )
}

export default MetadataLabel
